<template>
  <section class="physical-document-price-container" v-loading="isLoading">
    <img class="banner" src="../../imgs/document_banner.png" alt="" />
    <ListItem :list="listData" _internal_="document" />
    <Empty iconType="2" title="暂无数据" v-if="!listData.length" />
  </section>
</template>

<script>
import ListItem from "../components/listItem";
import { getYouZanKeGoods } from "@/api/distribution";

export default {
  data() {
    return {
      isLoading: false,
      listData: [],
    };
  },
  components: {
    ListItem,
  },
  methods: {
    load() {
      this.isLoading = true;
      const params = {
        pageNum: 1,
        pageSize: 10,
        categoryId: "",
        titleLike: "",
        orderBy: "",
        orderFlag: "",
        source: "",
        directionalFlag: false,
        minPrice: "",
        maxPrice: "",
        minCommissionRate: "",
        maxCommissionRate: "",
        hasDocument: true,
      };
      getYouZanKeGoods(params).then((res) => {
        this.isLoading = false;
        if (res.success) {
          this.listData = res.data.goodList || [];
        }
      });
    },
  },
  created() {
    this.load();
  },
};
</script>

<style lang="scss">
.physical-document-price-container {
  position: relative;
  .banner {
    width: 750px;
    height: 160px;
  }
}
</style>
